module.exports = __webpack_public_path__ + "img/help-white-text.91835147.svg";